import { useAppSelector } from 'redux/hooks';
import { Auth0Profile } from './auth/AuthService';

export const useCurrentUser = (): Auth0Profile => {
  const { profile: currentUserProfile } = useAppSelector((state) => state.auth);
  return currentUserProfile;
};
